{
  "static-content-online-booking-benefit": {
    "buttons": {},
    "text": {
      "title-1": "Đặt lịch trực tuyến, ",
      "title-2": "ưu đãi ngập tràn!",
      "description": "Trải nghiệm sự tiện lợi tối đa với công cụ đặt lịch trực tuyến của chúng tôi. Dù là ngày hay đêm, bạn có thể lên lịch hẹn 24/7 từ mọi nơi, chỉ bằng thiết bị thông minh và kết nối internet. Ngoài ra, còn có quyền truy cập vào các ưu đãi đặc biệt như các chương trình giảm giá, khung giờ vàng. Đặt ngay và tận hưởng những lợi ích của việc đặt lịch trực tuyến!",
      "any-time-title": "Đặt lịch 24/7",
      "any-time-description": "Bất cứ lúc nào bạn muốn",
      "any-where-title": "Đặt lịch không giới hạn",
      "any-where-description": "Bất kể bạn ở nơi đâu",
      "discount-title": "Ưu đãi khủng",
      "discount-description": "Nhanh tay săn ngay ưu đãi giảm giá lớn và các chương trình khuyến mãi giờ vàng độc quyền"
    }
  }
}
